export default function roleVerify(roleList, roleId) {
    return roleList.some((element) => {
        return element === roleId;
    });
}